import { getNoticeBannersByFilterForUser } from "api/noticeBannerApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { orgSelector } from "redux/selectors";
import { HiOutlineX } from 'react-icons/hi';
import "./noticeBanner.scss"

const NoticeBanner = () => {
    const [t] = useTranslation();
    const [siteMessage, setSiteMessage] = useState<any>(null);
    const [orgMessage, setOrgMessage] = useState<any>(null);
    const {organizationId} = useSelector(orgSelector);
    const [isCloseSiteMessage, setIsCloseSiteMessage] = useState(true);
    const [isCloseOrgMessage, setIsCloseOrgMessage] = useState(true);

    useEffect(() => {
        getNoticeBannersByFilterForUser({page: 0, limit: 1, type: "SITE", isActive: true}).then(res => {
            if (res?.data?.totalEntities > 0) {
                setSiteMessage(res?.data?.entities[0]);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getNoticeBannersByFilterForUser({page: 0, limit: 1, type: "ORGANIZATION", organizationId, isActive: true }).then(res => {
            if (res?.data?.totalEntities > 0) {
                setOrgMessage(res?.data?.entities[0]);
            } else {
                setOrgMessage(null);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId])

    const handleCloseSiteMessage = () => {
        setIsCloseSiteMessage(false);
    };

    const handleCloseOrgMessage = () => {
        setIsCloseOrgMessage(false);
    };

    return (
        <>
        <div className="flex banner-full">
            {siteMessage && isCloseSiteMessage && (
                    <div className={`notice-banner`}>
                        <div className="flex items-center">
                            <span className="text-white notice-banner-tag">{t('noticeBannerPage.siteMessage')}</span>
                            <span className="text-white ml-4">{siteMessage.message}</span>
                        </div>
                        <button className="text-white close-btn" onClick={handleCloseSiteMessage}>
                            <HiOutlineX size={20}/>
                        </button>
                    </div>
            )}
            {orgMessage && isCloseOrgMessage && (
                    <div className={`notice-banner`}>
                        <div className="flex items-center">
                            <span className="text-white notice-banner-tag">{t('noticeBannerPage.orgMessage').replace('{OrgName}', orgMessage.organization?.name)}</span>
                            <span className="text-white ml-4">{orgMessage.message}</span>
                        </div>
                        <button className="text-white close-btn" onClick={handleCloseOrgMessage}>
                            <HiOutlineX size={20}/>
                        </button>
                    </div>
            )}
        </div>
        </>
    )
}

export default NoticeBanner;
